var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 42,
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 20.9998C0.5 9.67835 9.67814 0.5 20.9996 0.5C32.3212 0.5 41.5 9.6781 41.5 20.9998C41.5 32.3209 32.3212 41.5 20.9996 41.5C9.67816 41.5 0.5 32.321 0.5 20.9998Z",
  fill: "white",
  stroke: "#999999"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_1222_50240",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 42,
  height: 42
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 20.9998C0.5 9.67835 9.67814 0.5 20.9996 0.5C32.3212 0.5 41.5 9.6781 41.5 20.9998C41.5 32.3209 32.3212 41.5 20.9996 41.5C9.67816 41.5 0.5 32.321 0.5 20.9998Z",
  fill: "white",
  stroke: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1222_50240)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.6562 40.3571L32.428 30.7372C32.008 27.4389 29.1965 25 25.8654 25H16.8101C13.4789 25 10.6667 27.4389 10.2475 30.7372L9.01852 40.3752C8.93392 41.0492 9.14164 41.8966 9.59108 42.4047C10.0413 42.9136 10.6886 43.375 11.3685 43.375H31.3063C31.9861 43.375 32.6334 42.9046 33.0844 42.3957C33.5338 41.8853 33.7416 41.0319 33.6562 40.3571Z",
  fill: "#999999"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.0875,
  cy: 15.0875,
  r: 7.0875,
  fill: "#999999"
}))));
export default SvgAvatar;